export const initDisclaimer = () => {
  // 背面のスクロールを無効にする関数
  function disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  // 背面のスクロールを復元する関数
  function enableBodyScroll() {
    document.body.style.overflow = '';
  }

  // クッキーを取得する関数
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // クッキーを設定する関数（非同期）
  function setCookie(name, value, days) {
    return new Promise((resolve) => {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
      resolve();
    });
  }

  // モーダルを閉じる関数（非同期処理でクッキーを設定）
  async function closeModal() {
    const modal = document.getElementById("disclaimer");
    if (modal) {
      modal.remove();
      enableBodyScroll();
      await setCookie("disclaimerAgreed", "true", 365);
    }
  }

  // クッキーが存在しない場合のみモーダルを表示する
  if (!getCookie("disclaimerAgreed")) {
    const disc = document.querySelector("#disclaimer");
    if (disc) {
      disc.classList.add("-active");
      disableBodyScroll();
    }
    document.querySelectorAll(".agree-btn").forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        await closeModal();
      });
    });
  }
};
